import React from "react";

const Travel = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36", isRegular = false}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M8.545 32.333c-3.614 0-6.545-2.955-6.545-6.6 0-3.645 2.93-6.6 6.545-6.6 3.615 0 6.546 2.955 6.546 6.6 0 3.645-2.93 6.6-6.546 6.6Zm0-2.933c2.009 0 3.637-1.642 3.637-3.667s-1.628-3.666-3.637-3.666c-2.008 0-3.636 1.641-3.636 3.666S6.537 29.4 8.545 29.4Zm18.91 2.933c-3.615 0-6.546-2.955-6.546-6.6 0-3.645 2.93-6.6 6.546-6.6 3.615 0 6.545 2.955 6.545 6.6 0 3.645-2.93 6.6-6.546 6.6Zm0-2.933c2.008 0 3.636-1.642 3.636-3.667s-1.628-3.666-3.637-3.666c-2.008 0-3.636 1.641-3.636 3.666s1.628 3.667 3.636 3.667ZM16.578 16.648l2.875 2.485v8.8h-2.909V20.6l-3.954-3.323a2.95 2.95 0 0 1-.409-4.492l4.114-4.148a2.892 2.892 0 0 1 4.114 0l2.057 2.074a10.105 10.105 0 0 0 5.698 2.895l-.015 2.957a12.993 12.993 0 0 1-7.74-3.778l-3.831 3.863Zm7.24-7.781c-1.607 0-2.91-1.314-2.91-2.934S22.212 3 23.82 3c1.606 0 2.908 1.313 2.908 2.933 0 1.62-1.302 2.934-2.909 2.934Z"
        />
    </svg>
);

export default Travel;
